import React, { Component } from 'react';
import { Modal, Table} from 'react-bootstrap';
import _ from 'lodash';

export default class ViewModeSampling extends Component { 
  constructor(props){
    super(props)
    this.state={
      toggle:true,
      toggleA:false,
      toggleT:false
      
    }
  } 
    handleCategories = () =>{
      this.setState((prevState) =>{
        return {toggleA: !prevState.toggleA};
      })
    }
    handleNature = () =>{
      this.setState((prevState) =>{
        return {toggle: !prevState.toggle};
      })
    }
    handleauditTypes = () =>{
      this.setState((prevState) =>{
        return {toggleT: !prevState.toggleT};
      })
    }

    render(){
      const{data} = this.props;
      const {toggleA, toggle, toggleT} = this.state;
      let name;  
      if(!_.has(this.props.data, 'templateTitle')){
        name = this.props.data.templateName
      } else {
        name = this.props.data.templateTitle;
      }
      let Regiontitle = '';
      let CallMixDataNature = _.filter(data.callMixCategories, {auditCategory: "NATURE OF CALL"})
      let CallMixDataDuration = _.filter(data.callMixCategories, {auditCategory: "DURATION OF CALL"})
      let CallMixDataType = _.filter(data.callMixCategories, {auditCategory: "TYPE OF CALL"})
      if(!_.isEmpty(data.region)){
        let region = data.region.regionName;
        let center = _.map(data.center, (x) =>{return x.centerName}).join(',');
        let clients = _.map(data.client, (x) =>{return x.clientName}).join(',');
        let process = _.map(data.process, (x) =>{return x.processName}).join(',');
        Regiontitle = region+" / "+center+" / "+clients+" / "+process
      }
      let auditList = [];
      if(_.isEmpty(data.auditTypeList)){
        if(!_.isEmpty(this.props.auditTypes) &&  !_.isEmpty(this.props.auditTypes.complianceTypeAudit)){
        _.map(this.props.auditTypes.complianceTypeAudit, obj =>{ 
          auditList.push({'auditType':obj, 'value':'0'}) }) 
        }
        
      } else {
        auditList = data.auditTypeList
      }
      return(
      <Modal show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w"
      size='xl'
      aria-labelledby="contained-modal-title-vcenter"
      centered>  
       <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title"> 
            {'View Sampling Criteria --'+name+'--'+Regiontitle}
            </Modal.Title>   
      </Modal.Header>
      <Modal.Body>
      <div>
      {!_.isEmpty(data.agentCategories) ? 
      <p>
        <h6 className={toggleA ? 'evalFormMargin': 'evalForm'} onClick={this.handleCategories} >
        {toggleA ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>}<b> AGENT CATEGORIES</b></h6>  
        <div className={toggleA ? 'assesmentShow': 'assesmentHide'}>                 
          <Table responsive>
              <thead onClick={this.handledoubleClickOut}>
                <th>AGENT CATEGORIES</th>
                <th>MIN AUDIT SCORE</th>
                <th>MAX AUDIT SCORE</th>
                <th>NO Of CALLS</th>
              </thead>
              <tbody >
             {_.map(data.agentCategories, (obj, index)=> {
                return(
                 <tr>
                   <td>{obj.category}</td>
                   <td>{obj.minScore}</td>
                  <td>{obj.maxScore}</td>
                  <td>{obj.noOfCalls}</td>
                 </tr>
                )
              })
              }
              </tbody>
            </Table> 
        </div>
      </p> : null}
      {(!_.isEmpty(data.callDurations) || !_.isEmpty(data.callNatures) || !_.isEmpty(data.callMixCategories) ) ?
      <p>
       <h6 className={toggle ? 'evalFormMargin': 'evalForm'} onClick={this.handleNature} >
        {toggle ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>}<b> NATURE AND DURATION OF CALL</b></h6>         
        <div className={toggle ? 'assesmentShow': 'assesmentHide'}> 
            <Table responsive>
              <thead>
              <th>CALL DURATION</th>
              <th>MIN</th>
              <th>MAX</th>
              </thead>
              <tbody>
              { _.map(data.callDurations, (obj, index)=>{
              return(
              <tr>
              <td>{obj.callDuration}</td>
              <td>{obj.min}</td>
              <td>{obj.max}</td>
              </tr>
              )
              })
              }
              </tbody>
            </Table>
            <Table responsive>
              <thead>
                  <th>CALL NATURE</th>
                  <th>START TIME</th>
                  <th>END TIME</th>
              </thead>
              <tbody>
                { 
                  _.map(data.callNatures, (obj, index)=>{
                  return(
                  <tr>
                  <td>{obj.callNature}</td>
                  <td>{obj.startTime}</td>
                  <td>{obj.endTime}</td> 
                  </tr>
                  )
                })
                }
              </tbody>
            </Table>
              &nbsp;<b>CALL MIX % DEFINITION</b>
              <Table responsive>
              <thead onClick={this.handleCallMixDoubleOut}>
              <th>AUDIT CATEGORY</th>
              <th>AUDIT TYPE</th>
              <th>PERCENTAGE</th>
              </thead>
              <tbody>
            { 
            _.map(CallMixDataNature, (obj, i)=>{                     
            return(
            <tr>
            <td>{obj.auditCategory}</td>
            <td>{obj.audit_type}</td>
            <td>{obj.percentage}</td>
            </tr>
            )
            })
            }</tbody>
            </Table>
            <Table responsive>
              <thead onClick={this.handleCallMixDoubleOut}>
              <th>AUDIT CATEGORY</th>
              <th>AUDIT TYPE</th>
              <th>PERCENTAGE</th>
              </thead>
              <tbody>
            { 
            _.map(CallMixDataDuration, (obj, i)=>{                     
            return(
            <tr onDoubleClick={this.handleCallMixDouble}>
            <td>{obj.auditCategory}</td>
            <td>{obj.audit_type}</td>
            <td>{obj.percentage}</td>
            </tr>
            )
            })
            }</tbody>
            </Table>
              <Table responsive>
              <thead onClick={this.handleCallMixDoubleOut}>
              <th>AUDIT CATEGORY</th>
              <th>AUDIT TYPE</th>
              <th>PERCENTAGE</th>
              </thead>
              <tbody>
              { 
            _.map(CallMixDataType, (obj, i)=>{                     
            return(
            <tr>
            <td>{obj.auditCategory}</td>
            <td>{obj.audit_type}</td>
            <td>{obj.percentage}</td>
            </tr>
            )
            })
            }</tbody>
            </Table>  
        </div>
      </p>
      : null }
        <h6 className={toggleT ? 'evalFormMargin': 'evalForm'} onClick={this.handleauditTypes} > 
        {toggleT ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>}<b> COMPLIANCE AUDIT CATEGORIES</b> </h6>  
        <div className={toggleT ? 'assesmentShow': 'assesmentHide'}>                 
          <Table responsive>
              <thead>
                <th>AUDIT TYPE</th>
                <th>COUNT</th>
              </thead>
              <tbody >
              {!_.isEmpty(auditList) ? _.map(auditList, (obj, index)=> {
                return(
                 <tr>
                   <td>{obj.auditType}</td>
                  <td>{obj.value ? obj.value : 0}</td>
                 </tr>
                )
              }) : null
              }
              </tbody>
            </Table> 
        </div> 

      </div> 
      </Modal.Body>      
      </Modal>
      )
    }
    
 
}

  